document.addEventListener('DOMContentLoaded', function() {
  const modal = document.getElementById('popup-sizes');
  const closeButton = document.querySelector('.close-button');

  document.querySelectorAll('.product-popup-size').forEach(button => {
    button.addEventListener('click', function() {
      modal.style.display = 'block';
    });
  });

  closeButton.addEventListener('click', function() {
    modal.style.display = 'none';
  });

  window.addEventListener('click', function(event) {
    if (event.target == modal) {
      modal.style.display = 'none';
    }
  });
});
